import React, { useEffect, useState } from 'react'
import Panel from './../common/Panel'
import PropTypes from 'prop-types'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import ListItemText from '@mui/material/ListItemText'
import { Table } from '@mui/material';import { TableBody } from '@mui/material';
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import { connect } from 'react-redux'
import { userAttributesTypes } from './../Attributes/AttributesArrays'
import { withLocalize } from 'react-localize-redux'

// class editItem extends React.Component {
const editItem=(props)=>{

  // constructor (props) {
  //   super(props)
  //   state = {
  //     selectedItem: []
  //   }
  //   formatObject = formatObject.bind(this)
  // }
  const [state, setState] = useState({
    selectedItem: []
   })

    useEffect(() => {
      setState((preState)=>({ 
        ...preState,
        selectedItem: formatObject(props) 
      }))
    }, [props])

  // componentDidMount () {
  //   setState({ selectedItem: formatObject(props) })
  // }
  // componentWillReceiveProps (nextprops) {
  //   if (nextprops) {
  //     setState({ selectedItem: formatObject(nextprops) })
  //   }
  // }
  const drawValue  = (item, key) => {
    let mainKey = ''
    switch (item.key) {
      case 'name':
        mainKey = props.translate('sharedName')
        break
      case 'login':
        mainKey = props.translate('loginTitle')
        break
      case 'email':
        mainKey = props.translate('userEmail')
        break
      case 'phone':
        mainKey = props.translate('sharedPhone')
        break
      case 'readonly':
        mainKey = props.translate('serverReadonly')
        break
      case 'administrator':
        mainKey = props.translate('userAdmin')
        break
      case 'map':
        mainKey = props.translate('mapTitle')
        break
      case 'twelveHourFormat':
        mainKey = props.translate('settingsTwelveHourFormat')
        break
      case 'coordinateFormat':
        mainKey = props.translate('settingsCoordinateFormat')
        break
      case 'disabled':
        mainKey = props.translate('sharedDisabled')
        break
      case 'expirationTime':
        mainKey = props.translate('userExpirationTime')
        break
      case 'deviceReadonly':
        mainKey = props.translate('userDeviceReadonly')
        break
      case 'token':
        mainKey = props.translate('userToken')
        break
      case 'limitCommands':
        mainKey = props.translate('userLimitCommands')
        break
      case 'poiLayer':
        mainKey = props.translate('mapPoiLayer')
        break
      case 'password':
        mainKey = props.translate('attributeDevicePassword')
        break
      case 'attributes':
        mainKey = props.translate('sharedAttributes')
        break
      default:
        mainKey = props.translate(item.key)
        break
    }
    if (typeof item.value === 'string' || item.value === null) {
      return (
        <Grid item xs={12} sm={6} md={4} key={key}>
          <ListItemText
            primary={item.value || 'null'}
            secondary={mainKey}
          ></ListItemText>
        </Grid>
      )
    }
    if (typeof item.value === 'boolean') {
      return (
        <Grid item xs={12} sm={6} md={4} key={key}>
          <ListItemText
            primary={item.value ? 'Yes' : 'No'}
            secondary={mainKey}
          ></ListItemText>
        </Grid>
      )
    } else if (typeof item.value === 'object') {
      let o = Object.keys(item.value)

      let h = null
      if (o.length) {
        h = o.map(k => {
          if (
            k !== 'serviceTitle' &&
            k !== 'footerText' &&
            k !== 'privacyPolicyLink' &&
            k !== 'termsLink'
          ) {
            const selectedTrans = userAttributesTypes.filter(el => el.key === k)
            if (typeof item.value[k] === 'boolean') {
              return (
                <TableRow key={k} style={{ height: 36 }}>
                  <TableCell component='th' width='250'>
                    {selectedTrans && selectedTrans[0]
                      ? props.translate(selectedTrans[0].name)
                      : k}
                  </TableCell>
                  <TableCell component='td'>
                    <strong
                      style={{ color: 'rgba(0, 0, 0, 0.87)', fontWeight: 600 }}
                    >
                      {item.value[k] ? 'Yes' : 'No'}
                    </strong>
                  </TableCell>
                </TableRow>
              )
            } else {
              return (
                <TableRow key={k} style={{ height: 36 }}>
                  <TableCell component='th'>
                    {selectedTrans && selectedTrans[0]
                      ? props.translate(selectedTrans[0].name)
                      : k}
                  </TableCell>
                  <TableCell component='td'>
                    <strong
                      style={{ color: 'rgba(0, 0, 0, 0.87)', fontWeight: 600 }}
                    >
                      {item.value[k]}
                    </strong>
                  </TableCell>
                </TableRow>
              )
            }
          }
          return null
        })
        let head = (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={key}
            style={{ display: 'block' }}
          >
            <Panel maxWidth={400} title={mainKey} bodyPadding={0}>
              <Table>
                <TableBody>{h}</TableBody>
              </Table>
            </Panel>
          </Grid>
        )
        return head
      }
      return null
    } else {
      return null
    }
  }

 const formatObject = (props) =>{
    if (props.selectedItem) {
      let normalValues = []
      let objValues = []
      Object.keys(props.selectedItem).map((itm) => {
        if (
          typeof props.selectedItem[itm] !== 'object' ||
          props.selectedItem[itm] === null
        ) {
          normalValues.push({ key: itm, value: props.selectedItem[itm] })
        } else {
          objValues.push({ key: itm, value: props.selectedItem[itm] })
        }

        return null
      })
      return normalValues.concat(objValues)
    } else {
      return []
    }
  }

  // render () {
    const { classes } = props

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Grid container spacing={0}>
            <Grid
              item
              md={12}
              style={{ position: 'relative', paddingRight: 16 }}
            >
              <h2 style={{ margin: '5px', marginBottom: '15px' }}>
                {props.translate('usersDetails')}
              </h2>
              {/* <GridList cellHeight={'auto'} cols={3} spacing={2}> */}
                {state.selectedItem &&
                  state.selectedItem.map((item, key) =>
                    drawValue(item, key, classes)
                  )}
              {/* </GridList> */}
            </Grid>
          </Grid>
        </Paper>
      </div>
    )
  // }
}

editItem.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapState = state => {
  return {
    users: state.users,
    logInUser: state.logInUsers,
    themecolors: state.themeColors
  }
}
const mapStateToProps = connect(mapState)
export const EditItem = mapStateToProps(
  withLocalize(editItem)
)
